import { createSelector } from 'reselect';
import {
  entitySelector,
  entitiesSelector
} from 'helpers/entitySelector';

const labelEntities = (state) => state.db.entities;
const labelResults = (state) => state.db.result;

const getSelectedLabels = (labels, results) => {
  const selectedLabels = results.filter((result) => {
    const labelId = !!result.childLabel ? result.childLabel.id : result;
    return !!labels[labelId];
  }).map((result) => {
    const labelId = !!result.childLabel ? result.childLabel.id : result;
    return labels[labelId];
  });
  return selectedLabels;
}

const getLabelSelector = createSelector(
  [labelEntities, labelResults],
  (entities, results)  => {
    const labelViewerLabelsEntity = entities.labels || [],
          labelViewerLabelsResults = results.labelViewerLabels || [];
    const selectedLabels = getSelectedLabels(labelViewerLabelsEntity, labelViewerLabelsResults),
          labelsTree = entitySelector(entities, results, 'label', 'labelParents'),
          labelDetails = entitySelector(entities, results, 'labelDetails', 'labelDetails'),
          filteredLabels = entitiesSelector(entities, results, 'filteredLabels', 'filteredLabels'),
          labelForecast = entitySelector(entities, results, 'labelForecasting', 'labelForecasting');

    return {
      selectedLabels,
      labelsTree,
      labelDetails,
      filteredLabels,
      labelForecast
    };
  }
);

export default getLabelSelector;



// WEBPACK FOOTER //
// ./src/components/labelViewer/label.selector.jsx